export const generateBars = (props): Record<string, {height?: number, color?: string, group?: string, [key: string]: unknown}[]> | undefined => {
 
  const { 
    data,
    axis_settings,
    color_key,
    colors,
    map_keys,
    grouping_key,
    is_grouped
  } = props || {}
 
  const bars = {} as Record<string, {height?: number, color?: string, group?: string, [key: string]: unknown}[]>
  
  const x = axis_settings?.bottom || axis_settings?.top
  const y = axis_settings?.left || axis_settings?.right
 
  let value_keys = y?.keys || y?.key
  if (!Array.isArray(value_keys)) {
    value_keys = [value_keys as string].filter(Boolean)
  }

  const domain_left = axis_settings?.left?.domain
  const max = domain_left?.[1]
 
  for (let i = 0; i < data?.length; i++) {
        
    const item = data?.[i]
    const color_id = item?.[color_key as string] as string | undefined || item?.[x?.key]
    let color = props?.color ||item?.color as string | undefined || colors?.[color_id as string] || colors?.[map_keys?.[color_id as string] as string] || undefined

    const x_val = item?.[x?.key]
    
    color = color || colors?.[color_id] || colors?.[map_keys?.[color_id] || color_id] || undefined
    
    if (!bars?.[x_val]) bars[x_val] = []

    value_keys?.forEach((y_key) => {

      const y_val = item?.[y_key]
      
      const bar_height = y_val / max * 100
      const new_bar = {
        group: is_grouped ? grouping_key ? String(item?.[grouping_key as string] || y_key) : y_key : undefined,
        index: i,
        left: x?.scale?.(x_val),
        height: bar_height,
        x_key: x?.key,
        y_key,
        [y_key]: y_val,
        [x?.key || 'x']: x_val,
        x_val,
        y_val,
        color: color || colors?.[String(item?.[grouping_key as string] || y_key)] || 'red',
        data: item
      }
       
      bars[x_val]?.push(new_bar)
    })
 
  



  }
 
  return bars
}